<!--
// Copyright © 2020, 2021 Anticrm Platform Contributors.
//
// Licensed under the Eclipse Public License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License. You may
// obtain a copy of the License at https://www.eclipse.org/legal/epl-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
//
// See the License for the specific language governing permissions and
// limitations under the License.
-->
<script lang="ts">
  import { Asset, getMetadata } from '@hcengineering/platform'
  import { AnySvelteComponent, IconSize } from '../types'
  import { ComponentType } from 'svelte'

  export let icon: Asset | AnySvelteComponent | ComponentType
  export let size: IconSize
  export let iconProps: any | undefined = undefined
  export let fill: string | undefined = 'currentColor'

  function isAsset (icon: Asset | AnySvelteComponent): boolean {
    return typeof icon === 'string'
  }

  function toAsset (icon: AnySvelteComponent | Asset): Asset {
    return icon as Asset
  }

  let url: string
  $: url = isAsset(icon) ? (getMetadata(toAsset(icon)) ?? '') : ''

  $: _fill = iconProps?.fill ?? fill

  // `color` is set alongside `fill` so stroke-based icons pick up the same value.
  // Stroke-based sprites declare stroke="currentColor", which resolves against the
  // CSS color property — not against the fill attribute. Without this, passing a
  // colour (a palette entry for a project icon, for example) tinted filled icons
  // but left outline icons rendering in the inherited text colour.
</script>

{#if isAsset(icon)}
  <svg class="svg-{size}" fill={_fill} style:color={_fill} {...iconProps}>
    {#if url !== ''}
      <use href={url} />
    {/if}
  </svg>
{:else if typeof icon !== 'string'}
  <svelte:component this={icon} {size} fill={_fill} {...iconProps} />
{/if}
